import { Switch as SwitchPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";

/** Primer's ToggleSwitch: an On/Off status label beside the track, for settings that apply immediately or on submit. */
function Switch({ className, checked, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <span className="inline-flex items-center gap-2">
      <span aria-hidden className="text-xs text-muted-foreground tabular-nums">
        {checked ? "On" : "Off"}
      </span>
      <SwitchPrimitive.Root
        data-slot="switch"
        checked={checked}
        className={cn(
          "inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border border-input bg-muted p-0.5 transition-colors",
          "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-50",
          "data-[state=checked]:border-ring data-[state=checked]:bg-ring",
          className,
        )}
        {...props}
      >
        <SwitchPrimitive.Thumb className="block size-3.5 rounded-full border border-input bg-background shadow-sm transition-transform data-[state=checked]:translate-x-4 data-[state=checked]:border-ring" />
      </SwitchPrimitive.Root>
    </span>
  );
}

export { Switch };
